/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("GridWidget", ["WidgetGridLayoutBase", "WidgetFactory"], function (context, cls) {
  /**
   * Grid widget.
   * @class GridWidget
   * @memberOf classes
   * @extends classes.WidgetGridLayoutBase
   */
  cls.GridWidget = context.oo.Class(cls.WidgetGridLayoutBase, function ($super) {
    return /** @lends classes.GridWidget.prototype */ {
      __name: "GridWidget",
      _scrollAreaWidget: null,

      /**
       * @inheritDoc
       */
      destroy: function () {
        this._scrollAreaWidget = null;
        $super.destroy.call(this);
      },

      /**
       * @inheritDoc
       */
      addChildWidget: function (widget, options) {
        if (widget instanceof cls.ScrollAreaWidget) {
          this._scrollAreaWidget = widget;
        }
        $super.addChildWidget.call(this, widget, options);
      },

      /**
       * @inheritDoc
       */
      removeChildWidget: function (widget, options) {
        if (widget instanceof cls.ScrollAreaWidget) {
          this._scrollAreaWidget = null;
        }
        $super.removeChildWidget.call(this, widget, options);
      },

      /**
       * @inheritDoc
       */
      buildExtraContextMenuActions: function (contextMenu, sourceWidget) {
        // Clipboard actions are only added if clipboard API is available
        if (!context.ClipboardService.isApiAvailable() || !this._scrollAreaWidget) {
          if (this.getParentWidget()) {
            this.getParentWidget().buildExtraContextMenuActions(contextMenu, sourceWidget);
          }
          return;
        }

        this.emit(gbc.constants.widgetEvents.buildContextMenuCopyArrayActions, contextMenu, sourceWidget);

        if (this.getParentWidget()) {
          this.getParentWidget().buildExtraContextMenuActions(contextMenu, sourceWidget);
        }
      }
    };
  });
  cls.WidgetFactory.registerBuilder("Grid", cls.GridWidget);
});
